import { CrawlerView } from './crawler';

export function CrawlerScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <CrawlerView />
    </div>
  );
}
